module.exports = __webpack_public_path__ + "static/img/2-2.5b9a2e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-2/2-2.jpg
// module id = 729
// module chunks = 1